import { NpcDefinition } from '../types/npc.types';

/**
 * Hub stations — the character's bedroom. The "awake" side of the room
 * (carnet, classeur) and the "dream bubble" around the bed (objects chest,
 * merchant, object-deepening) are surfaced as interactable stations.
 * Seul `cartographer` est `defaultUnlocked`. Les autres sont débloqués au
 * retour au hub après la complétion de D1 / D2 par `HubArrivalService`
 * (cf. docs/superpowers/specs/2026-06-11-hub-progression-cinematics-design.md).
 *
 * Convention: the order in the registry determines the display order in the
 * MainMenu grid. Names are placeholders until the story locks them in.
 */
export const NPC_REGISTRY: Record<string, NpcDefinition> = {
  cartographer: {
    id: 'cartographer',
    label: 'Carnet de rêves',
    greeting: 'Tu ouvres ton carnet. Quelle nuit veux-tu revivre ?',
    services: [
      {
        id: 'view-map',
        label: 'Choisir un rêve',
        kind: 'view-dungeon-map',
      },
    ],
    defaultUnlocked: true,
  },
  bestiary: {
    id: 'bestiary',
    label: 'Classeur de cartes',
    greeting: 'Les visages croisés dans tes rêves, croqués un à un.',
    services: [
      {
        id: 'view-bestiary',
        label: 'Feuilleter le classeur',
        kind: 'view-bestiary',
      },
    ],
    defaultUnlocked: false,
  },
  'chest-keeper': {
    id: 'chest-keeper',
    label: 'Coffre du rêve',
    greeting: 'Ce que tu as ramené de tes rêves repose ici.',
    services: [
      {
        id: 'open-chest',
        label: 'Déposer / Retirer',
        kind: 'open-screen',
        target: 'chest',
      },
    ],
    defaultUnlocked: false,
  },
  commode: {
    id: 'commode',
    label: 'Commode',
    greeting:
      'Tes objets précieux. Plus ils comptent pour toi, plus ils marquent tes rêves.',
    services: [
      {
        id: 'work-trinkets',
        label: 'Approfondir mes objets',
        kind: 'open-screen',
        target: 'commode',
      },
    ],
    defaultUnlocked: false,
  },
  shop: {
    id: 'shop',
    label: 'Marchand du rêve',
    greeting: 'Voici ce que le rêve a déposé aujourd’hui. Jette un œil.',
    services: [
      // `apothecary` is the rolling "Vendeur": random stock (4 consumables +
      // 2 grimoires) redrawn each run cycle. cf. ShopService + docs/hub.md.
      {
        id: 'shop',
        label: 'Acheter / Vendre',
        kind: 'view-shop',
        target: 'apothecary',
      },
    ],
    defaultUnlocked: false,
  },
  loadout: {
    id: 'loadout',
    label: 'Équipement',
    greeting: 'Tes trésors, babioles, sorts et croquis équipés.',
    services: [
      {
        id: 'open-loadout',
        label: 'Gérer l’équipement',
        kind: 'open-screen',
        target: 'loadout',
      },
    ],
    defaultUnlocked: false,
  },
  'talent-tree': {
    id: 'talent-tree',
    label: 'Mur de Confiance',
    greeting: 'Ta Confiance, épinglée au mur.',
    services: [
      {
        id: 'open-talents',
        label: 'Dépenser ma Confiance',
        kind: 'open-screen',
        target: 'talents',
      },
    ],
    defaultUnlocked: false,
  },
  'multiplayer-station': {
    id: 'multiplayer-station',
    label: 'Lien onirique',
    greeting: '',
    services: [
      {
        id: 'open-multiplayer',
        label: 'Multijoueur',
        kind: 'open-interface',
        target: 'multiplayer',
      },
    ],
    defaultUnlocked: true,
  },
};
